import React, { useState, useEffect, useRef, useContext } from "react";

// ------------------ COMPONENTES DE PRIMEREACT --------------------------
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";

// ------------------ COMPONENTES DE BASE --------------------------------
import Card from "../../../../Base/Components/Card/Card";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { obtenerCategorias } from "../../../../Base/API/Global/Categorias/CategoriasRequests";

// ------------------- CONSULTAS A LA API --------------------------------
// ------------------ COMPONENTES DE NECESARIOS --------------------------
import CategoriasCrudModal from "./ModalCategorias/CategoriasCrudModal";

export const CategoriasScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [categoria, setCategoria] = useState("");
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(true);

  const getInfo = async () => {
    setLoading(true);
    const r = await obtenerCategorias();
    setCategoria(r.filter(i=> i?.IdStatus !== 7));
    setLoading(false);
  };

  const colums = [
    {
      field: "IdCategoria",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "NombreCategoria",
      header: "Categorías",
      headerEn: "Categories",
      flex: 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Type",
      header: "Tipo",
      headerEn: "Type",
      flex: 1,
    },
    {
      field: "Comentario",
      header: "Comentario",
      headerEn: "Comment",
      flex: 1,
    },
    { field: "EsServicio", header: "Es Servicio", headerEn: " Is Service", width: 100, filter: false },
    // {
    //   field: "IdCuentaFinanzas",
    //   header: "ID Cuenta Finanzas",
    //   headerEn: "Finance Account ID",
    //   flex: 1,
    // },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "small",
      Format: "Estado",
      filter: false,
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
    },
    {
      field: "IdCategoria",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          className: "custom-tooltip",
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
          tooltipOptions: {
            position: "left",
          },
        },
      ],
    },
  ];

  const table = {
    Columns: colums,
    Data: categoria,
    loading: loading,
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "tipoProducto", config.language));
    getInfo();
  }, []);

  return (
    <div
      className=" p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast}></Toast>
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "categoria", config.language)}</h3>
            <Button icon='pi pi-refresh' onClick={getInfo} />
            <Button
              icon='pi pi-plus' 
              severity='success' 
              onClick={() => {
                setShowDialog(true);
                setSelected(null);
              }} 
            />
          </div>
        }
        contenido={
          <div className="p-4" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />
       {showDialog && (
        <CategoriasCrudModal
          toastRef={toast}
          categoriasDialog={showDialog}
          categoria={selected}
          setCategoriasDialog={setShowDialog}
          getCategorias={getInfo}
          modo={selected ? "Editar" : "Crear"}
        />
      )}
    </div>
  );
};

export default CategoriasScreen;
